var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContactGroupForm',{attrs:{"description":_vm.description},on:{"submit":function($event){return _vm.onSubmit($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }